import React from 'react';
import i18n from "i18next";
import { Menu, Dropdown, Button, Space } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { Export2PDF, Export2Doc } from"./Export2Doc.js";


const ExportToDocument = (props) => {

  const items = [
    {
      key: '1',
      label: i18n.t('components.export.doc_book'),
    },
    {
      key: '2',
      label: i18n.t('components.export.doc_album'),
    },
    {
      key: '0',
      //dashed : true,
      type: 'divider'
    },
    {
      key: '3',
      label: i18n.t('components.export.pdf_book'),
    },
    {
      key: '4',
      label: i18n.t('components.export.pdf_album'),
    },
  ];


  const onMenuClick = (e) => {
    console.log('click', e.key, props.element, i18n.t('components.export.pdf_book'));
    const title = (props.title)?props.title: document.title;
    switch (e.key){
      case '1' : Export2Doc(props.element, 0, title); break;
      case '2' : Export2Doc(props.element, 1, title); break;
      case '3' : Export2PDF(props.element, 0, title); break;
      case '4' : Export2PDF(props.element, 1, title); break;
      default:
        console.log("!!!!", e.key);
    }
  };
  
  
  const userMenu = (
    <Menu icon={<ExportOutlined />}>
      <Menu.Item key="1">В Doc (книжный)</Menu.Item>
      <Menu.Item key="2">В Doc (альбомный)</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">В Pdf (книжный)</Menu.Item>
      <Menu.Item key="4">В Pdf (альбомный)</Menu.Item>
    </Menu>
  );  
  return (
      <Dropdown
        menu={{
          items,
          onClick: onMenuClick,
        }}        
      >
        <Button icon={<ExportOutlined />}>          
        </Button>        
      </Dropdown>
  );
};

export default ExportToDocument;